import { createPhasedAction } from 'redux/actionCreators'

export const { renewalAnnualGetSagepayurlAction } = createPhasedAction('RENEWAL_ANNUAL_GET_SAGEPAYURL_ACTION')

export const { renewalValidateDirectDebitAction } = createPhasedAction('RENEWAL_VALIDATE_DIRECT_DEBIT_ACTION')

export const { renewalBindPaymentAction } = createPhasedAction('RENEWAL_BIND_PAYMENT_ACTION')
